import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../../Styles/footer.css';

export default class Footer extends Component {
  render() {
    const currentYear = new Date().getFullYear();
    
    // Partner hotels data
    const partnerHotels = [
      { name: 'KTDC Hotels', logo: '/assets/img/ktdc-logo.png', url: 'https://www.ktdc.com/' },
      { name: 'Sterling Holidays', logo: '/assets/img/sterling.png', url: 'https://www.sterlingholidays.com/' },
      // { name: 'CGH Earth', logo: '/assets/partners/cgh-earth-logo.png', url: 'https://www.cghearth.com' },
      // { name: 'Kumarakom Lake Resort', logo: '/assets/partners/kumarakom-logo.png', url: 'https://www.kumarakomresort.com' },
      // { name: 'Vivanta by Taj', logo: '/assets/partners/vivanta-logo.png', url: 'https://www.vivantabytaj.com' },
      // { name: 'Ramada Resort', logo: '/assets/partners/ramada-logo.png', url: 'https://www.wyndhamhotels.com/ramada' },
    ];
    
    return (
      <footer className="modern-footer">
        <div className="footer-main">
          <Grid>
            {/* First Row: Logo, Kerala Tourism, and Company Info */}
            <Row className="footer-row top-row">
              <Col xs={12} md={5} className="footer-col">
                <div className="footer-logo-section">
                  <div className="logo-wrapper">
                    <img src="/assets/img/kairaly_logo.jpg" alt="Kairaly Holidays" className="footer-logo" />
                    <div className="kerala-god-own-country">
                      <img 
                        src="/assets/img/godsowncountry.jpg" 
                        alt="God's Own Country - Kerala Tourism" 
                        className="kerala-logo"
                      />
                      <div className="kerala-text">
                        <span className="tagline">God's Own Country</span>
                        <span className="department">Kerala Tourism</span>
                      </div>
                    </div>
                  </div>
                  <h3 className="footer-brand-name">Kairaly Hotels & Holidays</h3>
                  <p className="footer-description">
                    Your trusted travel partner for unforgettable journeys in God's Own Country.
                    Experience Kerala with the best travel services tailored just for you.
                  </p>
                </div>
              </Col>
              
              <Col xs={12} md={3} className="footer-col">
                <div className="footer-links-section">
                  <h4 className="footer-title">Quick Links</h4>
                  <div className="links-grid">
                    <Link to="/">Home</Link>
                    <Link to="/about">About Us</Link>
                    <Link to="/services">Services</Link>
                    <Link to="/destinations">Destinations</Link>
                    <Link to="/packages">Packages</Link>
                    <Link to="/contact">Contact</Link>
                    <Link to="/blog">Travel Blog</Link>
                    <Link to="/offers">Special Offers</Link>
                  </div>
                </div>
              </Col>
              
              <Col xs={12} md={4} className="footer-col">
                <div className="footer-social-section">
                  <h4 className="footer-title">Connect With Us</h4>
                  <div className="social-icons-group">
                    <a href="https://www.facebook.com/kairalyhotel" target="_blank" rel="noopener noreferrer" className="social-icon-fb">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://www.instagram.com/kairalyholidays" target="_blank" rel="noopener noreferrer" className="social-icon-ig">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="https://wa.me/9037675072" target="_blank" rel="noopener noreferrer" className="social-icon-wa">
                      <i className="fab fa-whatsapp"></i>
                    </a>
                    <a href="mailto:kairalyhotels@gmail.com" className="social-icon-em">
                      <i className="far fa-envelope"></i>
                    </a>
                    <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon-yt">
                      <i className="fab fa-youtube"></i>
                    </a>
                  </div>
                  <div className="newsletter-box">
                    <h5>Subscribe for Updates</h5>
                    <div className="newsletter-input">
                      <input type="email" placeholder="Enter your email" />
                      <button><i className="fas fa-paper-plane"></i></button>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            
            {/* Partner Hotels Section */}
            <Row className="footer-row partners-row">
              <Col xs={12}>
                <div className="partners-section">
                  <h4 className="partners-title">Our Premium Hotel Partners</h4>
                  <div className="partners-slider">
                    {partnerHotels.map((hotel, index) => (
                      <a 
                        key={index}
                        href={hotel.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="partner-item"
                        title={hotel.name}
                      >
                        <img src={hotel.logo} alt={hotel.name} />
                      </a>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
            
            {/* Second Row: Contact Information */}
            <Row className="footer-row contact-row">
              <Col xs={12} sm={6} md={3} className="contact-item">
                <div className="contact-card">
                  <div className="contact-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className="contact-details">
                    <h5>Visit Us</h5>
                    <p>Kairaly Hotels & Holidays</p>
                    <p>Alappuzha, Kerala, India</p>
                    <p>PIN: 688001</p>
                  </div>
                </div>
              </Col>
              
              <Col xs={12} sm={6} md={3} className="contact-item">
                <div className="contact-card">
                  <div className="contact-icon">
                    <i className="fas fa-phone-alt"></i>
                  </div>
                  <div className="contact-details">
                    <h5>Call Us</h5>
                    <p>+91 9037675072</p>
                    <p>+91 9497660163</p>
                    <p>Toll Free: 1800-123-4567</p>
                  </div>
                </div>
              </Col>
              
              <Col xs={12} sm={6} md={3} className="contact-item">
                <div className="contact-card">
                  <div className="contact-icon">
                    <i className="far fa-envelope"></i>
                  </div>
                  <div className="contact-details">
                    <h5>Email Us</h5>
                    <p>kairalyhotels@gmail.com</p>
                    <p>kairalyholidays@gmail.com</p>
                    <p>reservations@kairaly.com</p>
                  </div>
                </div>
              </Col>
              
              <Col xs={12} sm={6} md={3} className="contact-item">
                <div className="contact-card">
                  <div className="contact-icon">
                    <i className="far fa-clock"></i>
                  </div>
                  <div className="contact-details">
                    <h5>Working Hours</h5>
                    <p>Mon-Sat: 9AM - 8PM</p>
                    <p>Sun: 10AM - 5PM</p>
                    <p>24/7 Customer Support</p>
                  </div>
                </div>
              </Col>
            </Row>
            
            {/* Third Row: Payment, Certifications & Copyright */}
            <Row className="footer-row bottom-row">
              <Col xs={12} md={4} className="payment-section">
                <h5>We Accept</h5>
                <div className="payment-icons">
                  <i className="fab fa-cc-visa"></i>
                  <i className="fab fa-cc-mastercard"></i>
                  <i className="fab fa-cc-amex"></i>
                  <i className="fab fa-cc-paypal"></i>
                  <i className="fab fa-google-pay"></i>
                  <i className="fab fa-cc-apple-pay"></i>
                </div>
              </Col>
              
              <Col xs={12} md={4} className="certification-section">
                <div className="certification-badges">
                  <img src="/assets/badges/iso-certified.png" alt="ISO Certified" />
                  <img src="/assets/badges/tripadvisor.png" alt="TripAdvisor" />
                  <img src="/assets/badges/kerala-tourism-approved.png" alt="Kerala Tourism Approved" />
                </div>
              </Col>
              
              <Col xs={12} md={4} className="copyright-section">
                <p>&copy; {currentYear} Kairaly Hotels & Holidays. All rights reserved.</p>
                <div className="legal-links">
                  <Link to="/privacy">Privacy Policy</Link>
                  <span>|</span>
                  <Link to="/terms">Terms & Conditions</Link>
                  <span>|</span>
                  <Link to="/sitemap">Sitemap</Link>
                  <span>|</span>
                  <Link to="/cancellation">Cancellation Policy</Link>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
        
        {/* WhatsApp Float Button */}
        <a href="https://wa.me/9037675072" className="whatsapp-float" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-whatsapp"></i>
          <span className="tooltip">Chat with us!</span>
        </a>
      </footer>
    );
  }
}